<script setup lang="ts">
import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3"

const props = defineProps(nodeViewProps)
</script>

<template>
  <node-view-wrapper class="wrapper">
    <suspense>
      <panel-agent-file-inline :file-id="props.node.attrs.fileId" background />
    </suspense>
  </node-view-wrapper>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.wrapper
  @apply inline-block max-w-full
</style>
